import { motion } from 'framer-motion';
import { LANDING } from '@/constants/testIds';

const today = ['Insulated Tumblers', 'Sip Lids', 'Carry Sleeves'];
const tomorrow = ['Coffeeware', 'Desk Essentials', 'Travel Accessories', 'The KIVO Journal'];

export default function FutureVision() {
  return (
    <section
      id="future"
      data-testid={LANDING.futureTimeline}
      className="bg-[#FAF8F4] py-32 lg:py-44"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="text-[11px] tracking-[0.35em] uppercase text-[#CBBBA0] mb-6"
          >
            Chapter 08 · The Future
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.1 }}
            className="font-display text-[clamp(2.5rem,6vw,5rem)] leading-[0.95] tracking-[-0.03em] text-[#111]"
          >
            More than a bottle.<br />
            <span className="font-serif italic text-[#111]/70">A lifestyle, in chapters.</span>
          </motion.h2>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <motion.div
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1.4, ease: 'easeOut' }}
            style={{ transformOrigin: 'top' }}
            className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-[#111]/15"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
            {/* Today */}
            <div className="md:text-right md:pr-16">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9 }}
                className="text-[11px] tracking-[0.3em] uppercase text-[#CBBBA0] mb-6"
              >
                Today · 2025
              </motion.div>
              <motion.h3
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, delay: 0.1 }}
                className="font-display text-3xl md:text-5xl tracking-[-0.02em] text-[#111]"
              >
                Tumblers
              </motion.h3>
              <motion.ul
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={{
                  hidden: {},
                  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.3 } },
                }}
                className="mt-8 space-y-3 text-[15px] text-[#111]/70"
              >
                {today.map((t) => (
                  <motion.li
                    key={t}
                    variants={{ hidden: { opacity: 0, y: 10 }, visible: { opacity: 1, y: 0 } }}
                  >
                    {t}
                  </motion.li>
                ))}
              </motion.ul>

              {/* Node */}
              <div className="hidden md:block absolute left-1/2 -translate-x-1/2 mt-[-150px] md:mt-[6px]"
                style={{ top: 0, transform: 'translate(-50%, 20px)' }}
              >
                <span className="block w-3 h-3 bg-[#111] rounded-full" />
              </div>
            </div>

            {/* Tomorrow */}
            <div className="md:mt-32 md:pl-16">
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9 }}
                className="text-[11px] tracking-[0.3em] uppercase text-[#CBBBA0] mb-6"
              >
                Tomorrow · 2026 →
              </motion.div>
              <motion.h3
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, delay: 0.1 }}
                className="font-display text-3xl md:text-5xl tracking-[-0.02em] text-[#111]"
              >
                <span className="font-serif italic">The Everyday</span> Collection
              </motion.h3>
              <motion.ul
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={{
                  hidden: {},
                  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.3 } },
                }}
                className="mt-8 space-y-3 text-[15px] text-[#111]/70"
              >
                {tomorrow.map((t) => (
                  <motion.li
                    key={t}
                    variants={{ hidden: { opacity: 0, y: 10 }, visible: { opacity: 1, y: 0 } }}
                  >
                    {t}
                  </motion.li>
                ))}
              </motion.ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
